import { isFeatureEnabled } from 'owa-feature-flags';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { isSharePointLink } from 'owa-sharepoint-link-detector';
import { isOneDriveConsumerLink } from './isOneDriveConsumerLink';

export function getFileProviderType(url: string): AttachmentDataProviderType {
    if (isSharePointLink(url)) {
        return AttachmentDataProviderType.OneDrivePro;
    }

    if (!isFeatureEnabled('doc-link-filePicker')) {
        // AttachmentDataProviderType is server definition and hard to change.
        return null;
    }

    if (isOneDriveConsumerLink(url)) {
        return AttachmentDataProviderType.OneDriveConsumer;
    }

    return null;
}
